import queryString from 'query-string'
const apiURL = //"http://source-qa.a.ynet.co.il/mshort/content/2018/FallenAPI/api/";
"https://z.ynet.co.il/mShort/commerce/2016/AvrahamTalQuiz/api/";


const articlesApiRoot = apiURL + "GetArticle/";
const _getData = (url, params, slashParams = false) => {
    let _params = slashParams ?
        params.map(p => `/${p}`).join('') :
        queryString.stringify(params)

    return fetch(`${url}${_params}`);
}
const _postData = (url, params) => {
    return fetch(url, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: "POST",
        body: queryString.stringify(params)
    });
}

const jsonPipe = response => response.json();

const commentsApiRoot = 'https://z.ynet.co.il/mLong/Content/2017/TalkbackWS/api/Service/';
const CommentsApi = {
    like: articleId => _getData(`${commentsApiRoot}AddLike`, [articleId], true),
    dislike: articleId => _getData(`${commentsApiRoot}AddDislike`, [articleId], true),
    add: (author, title, content, articleId, parentId) =>
        _postData(`${commentsApiRoot}AddTalkback`, {
            authorName: author,
            title: title,
            content: content,
            articleId: articleId,
            parentId: parentId
        }),
    get: (articleId, bulkSize) =>
        _getData(
            `${commentsApiRoot}GetArticleTalkbacks`,
            [articleId, bulkSize],
            true).then(jsonPipe),
    getCount: articleId =>
        _getData(
            `${commentsApiRoot}GetTalkbackCount`,
            [articleId],
            true).then(jsonPipe)
}


const ArticlesApi = {
    get: articleId => {
        //        return _getData(`${articlesApiRoot}${articleId}.html`)
        return _getData(`${articlesApiRoot}${articleId}`)
            .then(
                response => response.json()
            ).then(
                (result) => {
                    let el = document.createElement('div');
                    el.innerHTML = result;
                    var fpvids = el.querySelectorAll(".flp6ScriptContainer");
                    var heighlight_a = el.querySelector(".heighlight_a");
                    heighlight_a.innerHTML = heighlight_a.innerHTML.split(' | ')[0];
                    fpvids.forEach(element => {
                        // remove this when possible - very dangerous!!!
                        element.nextSibling.nextSibling.nextSibling.nextSibling.innerHTML='';
                        element.id = "vid" + element.id;
                        element.dir = "ltr";
                    });
                    return el.querySelector("div.artiwrapper").outerHTML;
                }
            )
    },
    getVideoDetails: videoId =>
        _getData(`https://www.ynet.co.il/3rdparty/mobile/json/video/${videoId}/`)
            .then(jsonPipe)
}


export {
    ArticlesApi,
    CommentsApi
}



// WEBPACK FOOTER //
// ./src/API/api.js